// Shared, curated outdoor destination structure for location suggestions.
// Countries without an image are kept out of the visible list until an image is added.

const country = (id, image, names, regions) => ({ id, image, names, regions });
const region = (id, names) => ({ id, names });

export const OUTDOOR_COUNTRIES = [
  country('switzerland', '/static/imgs/switzerland.avif', {
    en: 'Switzerland',
    fr: 'Suisse',
    it: 'Svizzera',
    de: 'Schweiz',
  }, [
    region('aargau', { en: 'Aargau', fr: 'Argovie', it: 'Argovia', de: 'Aargau' }),
    region('appenzell-ausserrhoden', { en: 'Appenzell Ausserrhoden', fr: 'Appenzell Rhodes-Extérieures', it: 'Appenzello Esterno', de: 'Appenzell Ausserrhoden' }),
    region('appenzell-innerrhoden', { en: 'Appenzell Innerrhoden', fr: 'Appenzell Rhodes-Intérieures', it: 'Appenzello Interno', de: 'Appenzell Innerrhoden' }),
    region('basel-land', { en: 'Basel-Landschaft', fr: 'Bâle-Campagne', it: 'Basilea Campagna', de: 'Basel-Landschaft' }),
    region('basel-stadt', { en: 'Basel-Stadt', fr: 'Bâle-Ville', it: 'Basilea Città', de: 'Basel-Stadt' }),
    region('bern', { en: 'Bern', fr: 'Berne', it: 'Berna', de: 'Bern' }),
    region('fribourg', { en: 'Fribourg', fr: 'Fribourg', it: 'Friburgo', de: 'Freiburg' }),
    region('geneva', { en: 'Geneva', fr: 'Genève', it: 'Ginevra', de: 'Genf' }),
    region('glarus', { en: 'Glarus', fr: 'Glaris', it: 'Glarona', de: 'Glarus' }),
    region('graubunden', { en: 'Graubünden', fr: 'Grisons', it: 'Grigioni', de: 'Graubünden' }),
    region('jura', { en: 'Jura', fr: 'Jura', it: 'Giura', de: 'Jura' }),
    region('lucerne', { en: 'Lucerne', fr: 'Lucerne', it: 'Lucerna', de: 'Luzern' }),
    region('neuchatel', { en: 'Neuchâtel', fr: 'Neuchâtel', it: 'Neuchâtel', de: 'Neuenburg' }),
    region('nidwalden', { en: 'Nidwalden', fr: 'Nidwald', it: 'Nidvaldo', de: 'Nidwalden' }),
    region('obwalden', { en: 'Obwalden', fr: 'Obwald', it: 'Obvaldo', de: 'Obwalden' }),
    region('schaffhausen', { en: 'Schaffhausen', fr: 'Schaffhouse', it: 'Sciaffusa', de: 'Schaffhausen' }),
    region('schwyz', { en: 'Schwyz', fr: 'Schwytz', it: 'Svitto', de: 'Schwyz' }),
    region('solothurn', { en: 'Solothurn', fr: 'Soleure', it: 'Soletta', de: 'Solothurn' }),
    region('st-gallen', { en: 'St. Gallen', fr: 'Saint-Gall', it: 'San Gallo', de: 'St. Gallen' }),
    region('thurgau', { en: 'Thurgau', fr: 'Thurgovie', it: 'Turgovia', de: 'Thurgau' }),
    region('ticino', { en: 'Ticino', fr: 'Tessin', it: 'Ticino', de: 'Tessin' }),
    region('uri', { en: 'Uri', fr: 'Uri', it: 'Uri', de: 'Uri' }),
    region('valais', { en: 'Valais', fr: 'Valais', it: 'Vallese', de: 'Wallis' }),
    region('vaud', { en: 'Vaud', fr: 'Vaud', it: 'Vaud', de: 'Waadt' }),
    region('zug', { en: 'Zug', fr: 'Zoug', it: 'Zugo', de: 'Zug' }),
    region('zurich', { en: 'Zurich', fr: 'Zurich', it: 'Zurigo', de: 'Zürich' }),
  ]),
  country('italy', '/static/imgs/italy.avif', {
    en: 'Italy',
    fr: 'Italie',
    it: 'Italia',
    de: 'Italien',
  }, [
    region('abruzzo', { en: 'Abruzzo', fr: 'Abruzzes', it: 'Abruzzo', de: 'Abruzzen' }),
    region('aosta-valley', { en: 'Aosta Valley', fr: "Vallée d'Aoste", it: "Valle d'Aosta", de: 'Aostatal' }),
    region('apulia', { en: 'Apulia', fr: 'Pouilles', it: 'Puglia', de: 'Apulien' }),
    region('basilicata', { en: 'Basilicata', fr: 'Basilicate', it: 'Basilicata', de: 'Basilikata' }),
    region('calabria', { en: 'Calabria', fr: 'Calabre', it: 'Calabria', de: 'Kalabrien' }),
    region('campania', { en: 'Campania', fr: 'Campanie', it: 'Campania', de: 'Kampanien' }),
    region('emilia-romagna', { en: 'Emilia-Romagna', fr: 'Émilie-Romagne', it: 'Emilia-Romagna', de: 'Emilia-Romagna' }),
    region('friuli-venezia-giulia', { en: 'Friuli Venezia Giulia', fr: 'Frioul-Vénétie Julienne', it: 'Friuli-Venezia Giulia', de: 'Friaul-Julisch Venetien' }),
    region('lazio', { en: 'Lazio', fr: 'Latium', it: 'Lazio', de: 'Latium' }),
    region('liguria', { en: 'Liguria', fr: 'Ligurie', it: 'Liguria', de: 'Ligurien' }),
    region('lombardy', { en: 'Lombardy', fr: 'Lombardie', it: 'Lombardia', de: 'Lombardei' }),
    region('marche', { en: 'Marche', fr: 'Marches', it: 'Marche', de: 'Marken' }),
    region('molise', { en: 'Molise', fr: 'Molise', it: 'Molise', de: 'Molise' }),
    region('piedmont', { en: 'Piedmont', fr: 'Piémont', it: 'Piemonte', de: 'Piemont' }),
    region('sardinia', { en: 'Sardinia', fr: 'Sardaigne', it: 'Sardegna', de: 'Sardinien' }),
    region('sicily', { en: 'Sicily', fr: 'Sicile', it: 'Sicilia', de: 'Sizilien' }),
    region('trentino-alto-adige', { en: 'Trentino-Alto Adige', fr: 'Trentin-Haut-Adige', it: 'Trentino-Alto Adige', de: 'Trentino-Südtirol' }),
    region('tuscany', { en: 'Tuscany', fr: 'Toscane', it: 'Toscana', de: 'Toskana' }),
    region('umbria', { en: 'Umbria', fr: 'Ombrie', it: 'Umbria', de: 'Umbrien' }),
    region('veneto', { en: 'Veneto', fr: 'Vénétie', it: 'Veneto', de: 'Venetien' }),
  ]),
  country('france', '/static/imgs/france.avif', {
    en: 'France',
    fr: 'France',
    it: 'Francia',
    de: 'Frankreich',
  }, [
    region('auvergne-rhone-alpes', { en: 'Auvergne-Rhône-Alpes', fr: 'Auvergne-Rhône-Alpes', it: 'Alvernia-Rodano-Alpi', de: 'Auvergne-Rhône-Alpes' }),
    region('bourgogne-franche-comte', { en: 'Bourgogne-Franche-Comté', fr: 'Bourgogne-Franche-Comté', it: 'Borgogna-Franca Contea', de: 'Bourgogne-Franche-Comté' }),
    region('brittany', { en: 'Brittany', fr: 'Bretagne', it: 'Bretagna', de: 'Bretagne' }),
    region('centre-val-de-loire', { en: 'Centre-Val de Loire', fr: 'Centre-Val de Loire', it: 'Centro-Valle della Loira', de: 'Centre-Val de Loire' }),
    region('corsica', { en: 'Corsica', fr: 'Corse', it: 'Corsica', de: 'Korsika' }),
    region('grand-est', { en: 'Grand Est', fr: 'Grand Est', it: 'Grand Est', de: 'Grand Est' }),
    region('hauts-de-france', { en: 'Hauts-de-France', fr: 'Hauts-de-France', it: 'Alta Francia', de: 'Hauts-de-France' }),
    region('ile-de-france', { en: 'Île-de-France', fr: 'Île-de-France', it: 'Île-de-France', de: 'Île-de-France' }),
    region('normandy', { en: 'Normandy', fr: 'Normandie', it: 'Normandia', de: 'Normandie' }),
    region('nouvelle-aquitaine', { en: 'Nouvelle-Aquitaine', fr: 'Nouvelle-Aquitaine', it: 'Nuova Aquitania', de: 'Nouvelle-Aquitaine' }),
    region('occitanie', { en: 'Occitanie', fr: 'Occitanie', it: 'Occitania', de: 'Okzitanien' }),
    region('pays-de-la-loire', { en: 'Pays de la Loire', fr: 'Pays de la Loire', it: 'Paesi della Loira', de: 'Pays de la Loire' }),
    region('provence-alpes-cote-azur', { en: "Provence-Alpes-Côte d'Azur", fr: "Provence-Alpes-Côte d'Azur", it: 'Provenza-Alpi-Costa Azzurra', de: "Provence-Alpes-Côte d'Azur" }),
    region('guadeloupe', { en: 'Guadeloupe', fr: 'Guadeloupe', it: 'Guadalupa', de: 'Guadeloupe' }),
    region('french-guiana', { en: 'French Guiana', fr: 'Guyane', it: 'Guyana francese', de: 'Französisch-Guayana' }),
    region('martinique', { en: 'Martinique', fr: 'Martinique', it: 'Martinica', de: 'Martinique' }),
    region('mayotte', { en: 'Mayotte', fr: 'Mayotte', it: 'Mayotte', de: 'Mayotte' }),
    region('reunion', { en: 'Réunion', fr: 'La Réunion', it: 'Riunione', de: 'Réunion' }),
  ]),
  country('austria', '/static/imgs/austria.avif', {
    en: 'Austria',
    fr: 'Autriche',
    it: 'Austria',
    de: 'Österreich',
  }, [
    region('burgenland', { en: 'Burgenland', fr: 'Burgenland', it: 'Burgenland', de: 'Burgenland' }),
    region('carinthia', { en: 'Carinthia', fr: 'Carinthie', it: 'Carinzia', de: 'Kärnten' }),
    region('lower-austria', { en: 'Lower Austria', fr: 'Basse-Autriche', it: 'Bassa Austria', de: 'Niederösterreich' }),
    region('upper-austria', { en: 'Upper Austria', fr: 'Haute-Autriche', it: 'Alta Austria', de: 'Oberösterreich' }),
    region('salzburg', { en: 'Salzburg', fr: 'Salzbourg', it: 'Salisburgo', de: 'Salzburg' }),
    region('styria', { en: 'Styria', fr: 'Styrie', it: 'Stiria', de: 'Steiermark' }),
    region('tyrol', { en: 'Tyrol', fr: 'Tyrol', it: 'Tirolo', de: 'Tirol' }),
    region('vorarlberg', { en: 'Vorarlberg', fr: 'Vorarlberg', it: 'Vorarlberg', de: 'Vorarlberg' }),
    region('vienna', { en: 'Vienna', fr: 'Vienne', it: 'Vienna', de: 'Wien' }),
  ]),
  country('germany', '/static/imgs/germany.avif', {
    en: 'Germany',
    fr: 'Allemagne',
    it: 'Germania',
    de: 'Deutschland',
  }, [
    region('baden-wurttemberg', { en: 'Baden-Württemberg', fr: 'Bade-Wurtemberg', it: 'Baden-Württemberg', de: 'Baden-Württemberg' }),
    region('bavaria', { en: 'Bavaria', fr: 'Bavière', it: 'Baviera', de: 'Bayern' }),
    region('berlin', { en: 'Berlin', fr: 'Berlin', it: 'Berlino', de: 'Berlin' }),
    region('brandenburg', { en: 'Brandenburg', fr: 'Brandebourg', it: 'Brandeburgo', de: 'Brandenburg' }),
    region('bremen', { en: 'Bremen', fr: 'Brême', it: 'Brema', de: 'Bremen' }),
    region('hamburg', { en: 'Hamburg', fr: 'Hambourg', it: 'Amburgo', de: 'Hamburg' }),
    region('hesse', { en: 'Hesse', fr: 'Hesse', it: 'Assia', de: 'Hessen' }),
    region('lower-saxony', { en: 'Lower Saxony', fr: 'Basse-Saxe', it: 'Bassa Sassonia', de: 'Niedersachsen' }),
    region('mecklenburg-vorpommern', { en: 'Mecklenburg-Vorpommern', fr: 'Mecklembourg-Poméranie-Occidentale', it: 'Meclemburgo-Pomerania Anteriore', de: 'Mecklenburg-Vorpommern' }),
    region('north-rhine-westphalia', { en: 'North Rhine-Westphalia', fr: 'Rhénanie-du-Nord-Westphalie', it: 'Renania Settentrionale-Vestfalia', de: 'Nordrhein-Westfalen' }),
    region('rhineland-palatinate', { en: 'Rhineland-Palatinate', fr: 'Rhénanie-Palatinat', it: 'Renania-Palatinato', de: 'Rheinland-Pfalz' }),
    region('saarland', { en: 'Saarland', fr: 'Sarre', it: 'Saarland', de: 'Saarland' }),
    region('saxony', { en: 'Saxony', fr: 'Saxe', it: 'Sassonia', de: 'Sachsen' }),
    region('saxony-anhalt', { en: 'Saxony-Anhalt', fr: 'Saxe-Anhalt', it: 'Sassonia-Anhalt', de: 'Sachsen-Anhalt' }),
    region('schleswig-holstein', { en: 'Schleswig-Holstein', fr: 'Schleswig-Holstein', it: 'Schleswig-Holstein', de: 'Schleswig-Holstein' }),
    region('thuringia', { en: 'Thuringia', fr: 'Thuringe', it: 'Turingia', de: 'Thüringen' }),
  ]),
  country('spain', '/static/imgs/spain.avif', {
    en: 'Spain',
    fr: 'Espagne',
    it: 'Spagna',
    de: 'Spanien',
  }, [
    region('andalusia', { en: 'Andalusia', fr: 'Andalousie', it: 'Andalusia', de: 'Andalusien' }),
    region('aragon', { en: 'Aragon', fr: 'Aragon', it: 'Aragona', de: 'Aragonien' }),
    region('asturias', { en: 'Asturias', fr: 'Asturies', it: 'Asturie', de: 'Asturien' }),
    region('balearic-islands', { en: 'Balearic Islands', fr: 'Îles Baléares', it: 'Isole Baleari', de: 'Balearische Inseln' }),
    region('basque-country', { en: 'Basque Country', fr: 'Pays basque', it: 'Paesi Baschi', de: 'Baskenland' }),
    region('canary-islands', { en: 'Canary Islands', fr: 'Îles Canaries', it: 'Isole Canarie', de: 'Kanarische Inseln' }),
    region('cantabria', { en: 'Cantabria', fr: 'Cantabrie', it: 'Cantabria', de: 'Kantabrien' }),
    region('castile-and-leon', { en: 'Castile and León', fr: 'Castille-et-León', it: 'Castiglia e León', de: 'Kastilien und León' }),
    region('castilla-la-mancha', { en: 'Castilla-La Mancha', fr: 'Castille-La Manche', it: 'Castiglia-La Mancia', de: 'Kastilien-La Mancha' }),
    region('catalonia', { en: 'Catalonia', fr: 'Catalogne', it: 'Catalogna', de: 'Katalonien' }),
    region('ceuta', { en: 'Ceuta', fr: 'Ceuta', it: 'Ceuta', de: 'Ceuta' }),
    region('extremadura', { en: 'Extremadura', fr: 'Estrémadure', it: 'Estremadura', de: 'Extremadura' }),
    region('galicia', { en: 'Galicia', fr: 'Galice', it: 'Galizia', de: 'Galicien' }),
    region('la-rioja', { en: 'La Rioja', fr: 'La Rioja', it: 'La Rioja', de: 'La Rioja' }),
    region('madrid', { en: 'Madrid', fr: 'Madrid', it: 'Madrid', de: 'Madrid' }),
    region('melilla', { en: 'Melilla', fr: 'Melilla', it: 'Melilla', de: 'Melilla' }),
    region('murcia', { en: 'Murcia', fr: 'Murcie', it: 'Murcia', de: 'Murcia' }),
    region('navarre', { en: 'Navarre', fr: 'Navarre', it: 'Navarra', de: 'Navarra' }),
    region('valencian-community', { en: 'Valencian Community', fr: 'Communauté valencienne', it: 'Comunità Valenciana', de: 'Valencianische Gemeinschaft' }),
  ]),
  country('norway', '/static/imgs/norway.avif', {
    en: 'Norway',
    fr: 'Norvège',
    it: 'Norvegia',
    de: 'Norwegen',
  }, [
    region('agder', { en: 'Agder', fr: 'Agder', it: 'Agder', de: 'Agder' }),
    region('akershus', { en: 'Akershus', fr: 'Akershus', it: 'Akershus', de: 'Akershus' }),
    region('buskerud', { en: 'Buskerud', fr: 'Buskerud', it: 'Buskerud', de: 'Buskerud' }),
    region('finnmark', { en: 'Finnmark', fr: 'Finnmark', it: 'Finnmark', de: 'Finnmark' }),
    region('innlandet', { en: 'Innlandet', fr: 'Innlandet', it: 'Innlandet', de: 'Innlandet' }),
    region('more-og-romsdal', { en: 'Møre og Romsdal', fr: 'Møre og Romsdal', it: 'Møre og Romsdal', de: 'Møre og Romsdal' }),
    region('nordland', { en: 'Nordland', fr: 'Nordland', it: 'Nordland', de: 'Nordland' }),
    region('oslo', { en: 'Oslo', fr: 'Oslo', it: 'Oslo', de: 'Oslo' }),
    region('rogaland', { en: 'Rogaland', fr: 'Rogaland', it: 'Rogaland', de: 'Rogaland' }),
    region('telemark', { en: 'Telemark', fr: 'Telemark', it: 'Telemark', de: 'Telemark' }),
    region('troms', { en: 'Troms', fr: 'Troms', it: 'Troms', de: 'Troms' }),
    region('trondelag', { en: 'Trøndelag', fr: 'Trøndelag', it: 'Trøndelag', de: 'Trøndelag' }),
    region('vestfold', { en: 'Vestfold', fr: 'Vestfold', it: 'Vestfold', de: 'Vestfold' }),
    region('vestland', { en: 'Vestland', fr: 'Vestland', it: 'Vestland', de: 'Vestland' }),
    region('ostfold', { en: 'Østfold', fr: 'Østfold', it: 'Østfold', de: 'Østfold' }),
  ]),
  country('finland', '/static/imgs/finland.avif', {
    en: 'Finland',
    fr: 'Finlande',
    it: 'Finlandia',
    de: 'Finnland',
  }, [
    region('aland', { en: 'Åland', fr: 'Åland', it: 'Åland', de: 'Åland' }),
    region('central-finland', { en: 'Central Finland', fr: 'Finlande centrale', it: 'Finlandia centrale', de: 'Mittelfinnland' }),
    region('central-ostrobothnia', { en: 'Central Ostrobothnia', fr: 'Ostrobotnie centrale', it: 'Ostrobotnia centrale', de: 'Mittelösterbotten' }),
    region('kainuu', { en: 'Kainuu', fr: 'Kainuu', it: 'Kainuu', de: 'Kainuu' }),
    region('kanta-hame', { en: 'Kanta-Häme', fr: 'Kanta-Häme', it: 'Kanta-Häme', de: 'Kanta-Häme' }),
    region('kymenlaakso', { en: 'Kymenlaakso', fr: 'Kymenlaakso', it: 'Kymenlaakso', de: 'Kymenlaakso' }),
    region('lapland', { en: 'Lapland', fr: 'Laponie', it: 'Lapponia', de: 'Lappland' }),
    region('north-karelia', { en: 'North Karelia', fr: 'Carélie du Nord', it: 'Carelia settentrionale', de: 'Nordkarelien' }),
    region('north-ostrobothnia', { en: 'North Ostrobothnia', fr: 'Ostrobotnie du Nord', it: 'Ostrobotnia settentrionale', de: 'Nordösterbotten' }),
    region('north-savo', { en: 'North Savo', fr: 'Savonie du Nord', it: 'Savo settentrionale', de: 'Nordsavo' }),
    region('ostrobothnia', { en: 'Ostrobothnia', fr: 'Ostrobotnie', it: 'Ostrobotnia', de: 'Österbotten' }),
    region('paijat-hame', { en: 'Päijät-Häme', fr: 'Päijät-Häme', it: 'Päijät-Häme', de: 'Päijät-Häme' }),
    region('pirkanmaa', { en: 'Pirkanmaa', fr: 'Pirkanmaa', it: 'Pirkanmaa', de: 'Pirkanmaa' }),
    region('satakunta', { en: 'Satakunta', fr: 'Satakunta', it: 'Satakunta', de: 'Satakunta' }),
    region('south-karelia', { en: 'South Karelia', fr: 'Carélie du Sud', it: 'Carelia meridionale', de: 'Südkarelien' }),
    region('south-ostrobothnia', { en: 'South Ostrobothnia', fr: 'Ostrobotnie du Sud', it: 'Ostrobotnia meridionale', de: 'Südösterbotten' }),
    region('south-savo', { en: 'South Savo', fr: 'Savonie du Sud', it: 'Savo meridionale', de: 'Südsavo' }),
    region('southwest-finland', { en: 'Southwest Finland', fr: 'Finlande du Sud-Ouest', it: 'Finlandia sud-occidentale', de: 'Varsinais-Suomi' }),
    region('uusimaa', { en: 'Uusimaa', fr: 'Uusimaa', it: 'Uusimaa', de: 'Uusimaa' }),
  ]),
];

export const OUTDOOR_COUNTRY_IMAGE_BY_ID = OUTDOOR_COUNTRIES.reduce((acc, item) => {
  if (item.image) {
    acc[item.id] = item.image;
  }
  return acc;
}, {});

const COUNTRY_ORDER = {
  'en-US': ['switzerland', 'italy', 'france', 'austria', 'germany', 'spain', 'norway', 'finland'],
  'fr-FR': ['switzerland', 'france', 'italy', 'spain', 'austria', 'germany', 'norway', 'finland'],
  'it-IT': ['italy', 'switzerland', 'france', 'austria', 'germany', 'spain', 'norway', 'finland'],
  'de-DE': ['switzerland', 'austria', 'germany', 'italy', 'france', 'spain', 'norway', 'finland'],
};

const getLang = locale => (locale || 'en-US').split('-')[0];

const localize = (names, locale) => {
  const lang = getLang(locale);
  return names[lang] || names.en;
};

export const buildLocalizedOutdoorRegions = locale => {
  const order = COUNTRY_ORDER[locale] || COUNTRY_ORDER['en-US'];
  const countryById = OUTDOOR_COUNTRIES.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});

  return order
    .map(countryId => countryById[countryId])
    .filter(item => item?.image)
    .map(item => {
      const countryName = localize(item.names, locale);
      return {
        type: 'country',
        id: item.id,
        name: countryName,
        names: item.names,
        image: item.image,
        isCountry: true,
        regions: item.regions.map(regionItem => {
          const regionName = localize(regionItem.names, locale);
          return {
            type: 'region',
            id: `${regionItem.id}-${item.id}`,
            name: regionName,
            names: regionItem.names,
            searchQuery: `${regionName}, ${countryName}`,
            isRegion: true,
            parentCountry: item.id,
          };
        }),
      };
    });
};

const SUGGESTED_REGIONS = {
  'en-US': buildLocalizedOutdoorRegions('en-US'),
  'fr-FR': buildLocalizedOutdoorRegions('fr-FR'),
  'it-IT': buildLocalizedOutdoorRegions('it-IT'),
  'de-DE': buildLocalizedOutdoorRegions('de-DE'),
  en: buildLocalizedOutdoorRegions('en-US'),
  fr: buildLocalizedOutdoorRegions('fr-FR'),
  it: buildLocalizedOutdoorRegions('it-IT'),
  de: buildLocalizedOutdoorRegions('de-DE'),
};

export default SUGGESTED_REGIONS;
